<script setup lang="ts">

// 親コンポーネントからデータを受け取る
const props = defineProps({
  buttonText: {
    type: String,
    required: false,
    default: ""
  },
  icon: {
    type: String,
    required: false,
    default: ''
  },
  buttonClass: {
    type: String,
    required: false,
    default: ''
  },
  id: {
    type: String,
    required: false,
    default: ''
  }
});
const emit = defineEmits(['click']) 
</script>

<template>
  <a :id="id" :class="['button', buttonClass]" @click="emit('click')">
    <slot>{{ buttonText }}</slot>
    <template v-if="icon === 'arrow'">
      <span class="button-arrow"></span>
    </template>
    <template v-if="icon === 'external'">
      <span class="button-external"></span>
    </template>
  </a>
</template>

<style lang="scss" scoped>
.button {
  background: #F78C35;
  color: #fff;
  border-radius: 8px;
  padding: 3.5% 4.66% 4.66% 4.66%;
  font-size: px(18);
  font-weight: bold;
  width: 91.47%;
  cursor: pointer;
  position: relative;
  text-align: center;
  margin: 0 auto;
  display: block;
  box-sizing: border-box;
  &:hover {
    background: #F15A25;
  }
  &.is-disabled{
    background: #CCCCCC;
    cursor: default;
  }
}
:deep(.button-text-small) {
  font-size: px(10.5);
  display: block;
}
.button-arrow {
  display: inline-block;
  position: absolute;
  right: 8.75%;
  top: 33.75%;
  width: 8%;
  height: 35%;
  background: url('@/assets/images/compare/icon_chevron-right.svg') no-repeat center/contain;
  vertical-align: middle;
}
.button-external {
  display: inline-block;
  position: absolute;
  right: 8.75%;
  top: 33.75%;
  width: 8%;
  height: 35%;
  background: url('@/assets/images/compare/icon_arrow-top-right-on-square.svg') no-repeat center/contain;
  vertical-align: middle;
}
@include media(pc) {
  .button {
    padding: 12px 0 16px;
    font-size: 20px;
    width: 480px;
  }
  :deep(.button-text-small) {
    font-size: 14px;
    display: inline-block;
    margin-right: 3px;
  }
  .button-arrow {
    right: 24px;
    top: 15px;
    width: 24px;
    height: 24px;
  }
  .button-external{
    right: 24px;
  }
}
</style>
